import { useEffect, useState } from "react";
import DSTypography from "views/system-design/DSTypography";

const Clock = (props: { tz: string }): JSX.Element => {
  useEffect(() => {
    const interval = setInterval(
      () =>
        setTime(
          new Date().toLocaleString("en-US", {
            timeZone: props.tz,
            hour12: false,
          }),
        ),
      1000,
    );
    return () => clearInterval(interval);
  }, []);
  const [time, setTime] = useState(
    new Date().toLocaleString("en-US", { timeZone: props.tz, hour12: false }),
  );
  return (
    <DSTypography variant="body2" sx={{ whiteSpace: "nowrap" }}>
      LA time: {time}
    </DSTypography>
  );
};
export default Clock;
